(() => {
  if (window.__isooraProductDrawerRemoteInit) return;
  window.__isooraProductDrawerRemoteInit = true;

  const productDrawerRemote = {
    drawerSelector: '.product-form-drawer[data-remote-url]',
    bodySelector: '[data-product-drawer-remote-body]',
    loadingSelector: '[data-product-drawer-loading]',
  };

  const extractDrawerContent = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source =
      doc.querySelector('.page-default .rte') ||
      doc.querySelector('.page-default__container .rte') ||
      doc.querySelector('main .rte') ||
      doc.querySelector('.shopify-policy__body') ||
      doc.querySelector('.rte');

    if (!source) return '';

    const clone = source.cloneNode(true);

    clone.querySelectorAll('h1').forEach((el) => el.remove());
    clone.querySelectorAll('h4').forEach((el) => {
      const replacement = document.createElement('h3');
      for (const attr of el.attributes) replacement.setAttribute(attr.name, attr.value);
      replacement.innerHTML = el.innerHTML;
      el.replaceWith(replacement);
    });
    clone.querySelectorAll('[itemprop]').forEach((el) => {
      el.removeAttribute('itemprop');
    });
    clone.querySelectorAll('img').forEach((img) => {
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
    });

    return clone.innerHTML.trim();
  };

  const loadDrawerContent = async (drawer) => {
    if (!drawer) return;
    if (drawer.dataset.remoteLoaded === 'true' || drawer.dataset.remoteLoading === 'true') return;

    const url = drawer.dataset.remoteUrl;
    const body = drawer.querySelector(productDrawerRemote.bodySelector);
    const loading = drawer.querySelector(productDrawerRemote.loadingSelector);
    if (!url || !body) return;

    drawer.dataset.remoteLoading = 'true';
    if (loading) loading.hidden = false;

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const content = extractDrawerContent(html);

      body.innerHTML = content || '';
      drawer.dataset.remoteLoaded = 'true';
    } catch (error) {
      console.error('Product drawer content load failed:', error);
      body.innerHTML = '<p>Inhalt konnte nicht geladen werden.</p>';
    } finally {
      if (loading) loading.hidden = true;
      delete drawer.dataset.remoteLoading;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('[data-js-toggle]');
      if (!toggle) return;

      const targetId = toggle.getAttribute('data-target') || toggle.getAttribute('data-js-toggle');
      if (!targetId) return;

      const drawer = document.getElementById(targetId);
      if (!drawer || !drawer.matches(productDrawerRemote.drawerSelector)) return;

      loadDrawerContent(drawer);
    },
    true
  );
})();
